// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import React from "react";

import SoftBox from "../../../components/SoftBox";

import colors from "../../../assets/theme/base/colors";
import borders from "../../../assets/theme/base/borders";

function DataTableBodyCell({ noBorder, align, children }) {
  const { light } = colors;
  const { borderWidth } = borders;

  return (
    <SoftBox
      component="td"
      textAlign={align}
      sx={({ typography }) => ({
        fontSize: typography.size.sm,
        height: 65,
        verticalAlign: "middle",
        whiteSpace: "nowrap",
        "&:first-of-type": { pl: 2.875 },
        "&:last-child": { pr: 2.875 },
      })}
      borderBottom={noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`}
      py={1.375}
      px={2.125}
    >
      <SoftBox
        display="inline-block"
        width="max-content"
        color="dark"
        sx={{ verticalAlign: "middle" }}
      >
        {children}
      </SoftBox>
    </SoftBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
};

export default DataTableBodyCell;
